import React, { useEffect, useRef, useState } from 'react';

// import { translateComponent } from '@/utils/tolgee/translateComponent';
import { LomavisPostCard1 } from '@/lomavisSharedUi/atoms/cards/LomavisPostCard1';
import { LomavisCard1 } from '@/lomavisSharedUi/atoms/cards/LomavisCard1';
import { Button, ButtonGroup } from 'react-bootstrap';
import { translateComponent } from '@/utils/tolgee/translateComponent';
import { PLATFORM_LIST } from '@/config/constants';

interface sortOptions {
  name: string;
  title: string;
}

interface ILomavisBestPerformingPostsProps {
  /** The text to display inside the H1 heading */
  title: string;
  itemsToShow?: number;
  data: any[];
  sortOptions: sortOptions[];
  showProfileHead?: boolean;

  customFilterOptions?: Array<{ value: string; label: string }>;
  selectCustomFilter?: (item: string) => void;
  currentCustomFilter?: string;
}

/**
 * Templates: ILomavisBestPerformingPosts
 */

function getValueByPath(obj: any, path: string): any {
  return path
    .split(/[.[\]]+/) // cleaned up regex
    .filter(Boolean)
    .reduce((o, key) => (o && typeof o === 'object' ? o[key] : undefined), obj);
}

function sortByNestedKeyDesc(array: any[], path: string): any[] {
  return [...array].sort((a, b) => {
    const va = getValueByPath(a, path);
    const vb = getValueByPath(b, path);

    const na =
      typeof va === 'number' ? va : va == null ? null : Number(va) || 0;
    const nb =
      typeof vb === 'number' ? vb : vb == null ? null : Number(vb) || 0;

    if (na === null && nb === null) return 0;
    if (na === null) return 1; // null goes last
    if (nb === null) return -1;

    return nb - na;
  });
}

export const LomavisBestPerformingPosts: React.FC<
  ILomavisBestPerformingPostsProps
> = ({
  title,
  data,
  sortOptions,
  showProfileHead,
  customFilterOptions,
  currentCustomFilter,
  selectCustomFilter
}) => {
  const t = translateComponent('ILomavisBestPerformingPosts');
  const dropdownRef = useRef(null);
  const customDropdownRef = useRef(null);

  const [sortOption, setSortOption] = useState(sortOptions[0]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [sortedData, setSortedData] = useState(data);

  const [itemsToShow, setItemsToShow] = useState(3); // default to 3

  const [showCustomDropdown, setShowCustomDropdown] = useState(false);

  useEffect(() => {
    const newData = sortByNestedKeyDesc(
      data,
      `analytics.sum_${sortOption?.name}`
    );
    setSortedData(newData);
  }, [sortOption, data]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        showDropdown &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showDropdown]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        showCustomDropdown &&
        customDropdownRef.current &&
        !customDropdownRef.current.contains(e.target)
      ) {
        setShowCustomDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showCustomDropdown]);
  console.log('sortedData', sortedData);
  return (
    <LomavisCard1 showDownloadButton={false} title={title} showMoreInfo={false}>
      <div className="d-flex flex-column gap-1 w-100">
        <div className="w-100 d-flex justify-content-between">
          <ButtonGroup aria-label="Items to show">
            <Button
              variant="secondary"
              size="sm"
              className={
                itemsToShow === 3
                  ? 'bg-secondary border-secondary'
                  : 'bg-light text-dark border-secondary'
              }
              onClick={() => setItemsToShow(3)}
            >
              {t('top3')}
            </Button>

            <Button
              variant="secondary"
              size="sm"
              className={
                itemsToShow === 6
                  ? 'bg-secondary border-secondary'
                  : 'bg-light text-dark border-secondary'
              }
              onClick={() => setItemsToShow(6)}
            >
              {t('top6')}
            </Button>

            <Button
              variant="secondary"
              size="sm"
              className={
                itemsToShow === sortedData.length
                  ? 'bg-secondary border-secondary'
                  : 'bg-light text-dark border-secondary'
              }
              onClick={() => setItemsToShow(sortedData.length)}
            >
              {t('alll')}
            </Button>
          </ButtonGroup>

          <div className="d-flex gap-2">
            {currentCustomFilter && customFilterOptions?.length > 0 && (
              <div className="dropdown text-end" ref={customDropdownRef}>
                <button
                  className="btn btn-secondary btn-sm dropdown-toggle"
                  type="button"
                  aria-expanded={showCustomDropdown}
                  onClick={() => setShowCustomDropdown((prev) => !prev)}
                >
                  {
                    customFilterOptions?.find(
                      (item) => item?.value === currentCustomFilter
                    )?.label
                  }
                </button>
                <ul
                  className={`dropdown-menu${
                    showCustomDropdown ? ' show' : ''
                  }`}
                >
                  {customFilterOptions.map((item) => (
                    <li key={item.value} className="w-100 p-1">
                      <button
                        className={`dropdown-item${
                          item?.value === currentCustomFilter ? ' active' : ''
                        }`}
                        type="button"
                        onClick={() => {
                          selectCustomFilter(item.value);
                          setShowCustomDropdown(false);
                        }}
                      >
                        {item.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="dropdown text-end" ref={dropdownRef}>
              <button
                className="btn btn-secondary btn-sm dropdown-toggle"
                type="button"
                aria-expanded={showDropdown}
                onClick={() => setShowDropdown((prev) => !prev)}
              >
                {sortOption?.title}
              </button>
              <ul className={`dropdown-menu${showDropdown ? ' show' : ''}`}>
                {sortOptions.map((item) => (
                  <li key={item?.name} className="w-100 p-1">
                    <button
                      className={`dropdown-item${
                        item?.name === sortOption?.name ? ' active' : ''
                      }`}
                      type="button"
                      onClick={() => {
                        setSortOption(item);
                        setShowDropdown(false);
                      }}
                    >
                      {item?.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className={`row`}>
          <div className="row">
            {sortedData && sortedData.length > 0 ? (
              sortedData.slice(0, itemsToShow).map((item, index) => (
                <div key={index} className="col-12 col-sm-6 col-md-4 g-2">
                  <LomavisPostCard1
                    image={item?.preview_image_url}
                    text={item?.text}
                    platforms={PLATFORM_LIST.filter(
                      (platform) => item[`${platform}_post`] === true
                    )}
                    publicationDate={item?.publication_date}
                    analytics={item?.analytics}
                    showProfileHead={showProfileHead ?? false}
                    profile={item?.profile ?? {}}
                  />
                </div>
              ))
            ) : (
              <div className="col-12  h-400px d-flex justify-content-center align-items-center">
                <span className="text-center text-muted py-4 fs-3">
                  {t?.('noDataAvailable')}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </LomavisCard1>
  );
};
